import fp from 'lodash/fp'
import { withMemo } from 'react-hooks-combine'
import { genId } from 'utils/standard/strings'

import ValidationFormModel from './validation-form.model'

const withFormModel = (description, opts) => {
  const { id, as, deps } = {
    id: genId(),
    as: 'form',
    deps: ['initialValues'],
    ...opts,
  }

  const descFn = fp.isFunction(description)
    ? description
    : fp.constant(description)

  return withMemo(
    as,
    (state, props) => {
      const formConfig = descFn(state, props)
      return ValidationFormModel.fromDescription(id, formConfig)
    },
    deps
  )
}

export default withFormModel
